// extracted by mini-css-extract-plugin
export default {"mobilePagination":"list_mobilePagination__n-jft"};